// @ts-nocheck


import notification from 'antd/lib/notification';
import React, { Component } from 'react';
import styled from 'styled-components';
import Grid, { GridItem } from '../../../../components/layout/Grid';
import { Icon } from '../../../../components/ui';

import { Card, Spinner } from './../../../../components';
import { Option, Select } from './../../../../components/ant/Select';

import InstallEquipmentButton from './../InstallEquipmentButton';

const { Field } = Card;

const Wrapper = styled.div`
  padding: 16px;
`;
const AddButton = styled.span`
  cursor: pointer;
  color: #2770ff;
  display: flex;
  & .icon {
    margin-right: 5px;
  }
`;














class OptionalEquipmentForm extends Component {
  static defaultProps = {
    availableEquipments: []
  };
  state = {
    currentOptionalEquipmentId: null,
    visibleForm: false
  };

  onOptionalEquipmentSelect = (currentOptionalEquipmentId) => {
    this.setState({
      currentOptionalEquipmentId
    });
  };

  onAddClick = async (installDate) => {
    const { currentOptionalEquipmentId } = this.state;
    const { availableEquipments } = this.props;
    const optionalEquipment = availableEquipments.find(
      (item) => item.id === currentOptionalEquipmentId
    );
    if (optionalEquipment) {
      await this.props.onSubmit({ ...optionalEquipment, installDate });
      this.setState({
        currentOptionalEquipmentId: null,
        visibleForm: false
      });
    } else {
      notification.error({
        message: 'Необходимо выбрать доп. оборудование из списка'
      });
    }
  };

  handleAddButtonClick = () => this.setState({ visibleForm: true });

  render() {
    const { currentOptionalEquipmentId, visibleForm } = this.state;
    const {
      availableEquipments,
      handleSearch,
      fetchData,
      isLoading
    } = this.props;
    return (
      <Wrapper>
        {visibleForm ?
        <Grid gutter="16px">
            <GridItem>
              <Field label="Оборудование">
                <Select
                placeholder="Выберите оборудование"
                value={currentOptionalEquipmentId}
                onChange={this.onOptionalEquipmentSelect}
                showSearch
                onSearch={handleSearch}
                filterOption={false}
                defaultActiveFirstOption={false}
                onBlur={() => fetchData()}
                notFoundContent={
                <Spinner
                  isLoading={isLoading}
                  notFoundText="Оборудование не найдено" />

                }>

                  {availableEquipments.map((equipment) =>
                <Option key={equipment.id} value={equipment.id}>{`${
                  equipment.name} ${
                  equipment.brandName}`}</Option>
                )}
                </Select>
              </Field>
            </GridItem>
            <GridItem fullWidth>
              <InstallEquipmentButton
              onConfirm={this.onAddClick}
              disabled={!currentOptionalEquipmentId} />

            </GridItem>
          </Grid> :

        <AddButton onClick={this.handleAddButtonClick}>
            <Icon type="plus" />
            Добавить доп. оборудование
          </AddButton>
        }
      </Wrapper>);

  }
}

export default OptionalEquipmentForm;
